var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4569_10124)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00007 37.6001C12.3901 36.6301 19.1101 38.0301 22.5001 35.6001C25.8901 38.0301 32.6101 36.6301 36.0001 37.6001C36.0001 37.6001 39.5 38 39.0001 39.6001C38.3201 40.5701 37.3501 40.5901 36.0001 40.1001C32.6101 39.1301 25.8901 40.5601 22.5001 39.1001C19.1101 40.5601 12.3901 39.1301 9.00007 40.1001C7.65007 40.5901 6.68007 40.5701 6.00007 39.6001C5.50001 38 9.00007 37.6001 9.00007 37.6001Z",
    stroke: "#2F3233",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 33.6001C17.5 36.1001 27.5 36.1001 30 33.6001C30.5 32.1001 30 31.6001 30 31.6001C30 29.1001 27.5 27.6001 27.5 27.6001C33 26.1001 33.5 16.1001 22.5 12.1001C11.5 16.1001 12 26.1001 17.5 27.6001C17.5 27.6001 15 29.1001 15 31.6001C15 31.6001 14.5 32.1001 15 33.6001Z",
    stroke: "#2F3233",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 9.6001C25 10.2631 24.7366 10.899 24.2678 11.3679C23.7989 11.8367 23.163 12.1001 22.5 12.1001C21.837 12.1001 21.2011 11.8367 20.7322 11.3679C20.2634 10.899 20 10.2631 20 9.6001C20 8.93706 20.2634 8.30117 20.7322 7.83233C21.2011 7.36349 21.837 7.1001 22.5 7.1001C23.163 7.1001 23.7989 7.36349 24.2678 7.83233C24.7366 8.30117 25 8.93706 25 9.6001Z",
    stroke: "#2F3233",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 36.6001C12.39 35.6301 19.11 37.0301 22.5 34.6001C25.89 37.0301 32.61 35.6301 36 36.6001C36 36.6001 37.65 37.1401 39 38.6001C38.32 39.5701 37.35 39.5901 36 39.1001C32.61 38.1301 25.89 39.5601 22.5 38.1001C19.11 39.5601 12.39 38.1301 9 39.1001C7.65 39.5901 6.68 39.5701 6 38.6001C7.35 37.1401 9 36.6001 9 36.6001Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 32.6001C17.5 35.1001 27.5 35.1001 30 32.6001C30.5 31.1001 30 30.6001 30 30.6001C30 28.1001 27.5 26.6001 27.5 26.6001C33 25.1001 33.5 15.1001 22.5 11.1001C11.5 15.1001 12 25.1001 17.5 26.6001C17.5 26.6001 15 28.1001 15 30.6001C15 30.6001 14.5 31.1001 15 32.6001Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 8.6001C25 9.26314 24.7366 9.89902 24.2678 10.3679C23.7989 10.8367 23.163 11.1001 22.5 11.1001C21.837 11.1001 21.2011 10.8367 20.7322 10.3679C20.2634 9.89902 20 9.26314 20 8.6001C20 7.93706 20.2634 7.30117 20.7322 6.83233C21.2011 6.36349 21.837 6.1001 22.5 6.1001C23.163 6.1001 23.7989 6.36349 24.2678 6.83233C24.7366 7.30117 25 7.93706 25 8.6001Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 26.6001H27.5M15 30.6001H30M22.5 16.1001V21.1001M20 18.6001H25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4569_10124",
    x: 4.20068,
    y: 6.3501,
    width: 36.5986,
    height: 36.8152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4569_10124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4569_10124",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/bb.08fb3bd2df20da1bd2dc4a7489980375.svg";
export { ForwardRef as ReactComponent };